import {
  HeadphonesIcon,
  LogOut,
  Store,
  TruckIcon,
  WalletIcon,
} from "lucide-react";
import { useTranslation } from "react-i18next";
import { Link, useNavigate } from "react-router";

function MobileHeaderDropdown({
  user,
  handleClick,
  handleLogout,
  handleClose,
  anchorEl,
  open,
}) {
  const { t } = useTranslation()
  return (
    <div
      className="w-full h-auto 
    fixed inset-0 bottom-0 top-[15%] p-[19px]
     bg-white z-50 flex flex-col justify-end "
    >
      <div
        className=" w-auto 
            border-t
            flex gap-2 items-start py-2 pr-[14px] pl-[6px] flex-col"
      >
        <div className="flex items-center justify-center gap-2 ">
          <div className=" ">
            {user.profileImage?.url && (
              <img
                src={user.profileImage.url}
                alt="avatar"
                className="w-[35px] h-[35px] rounded-full object-cover"
              />
            )}
            {!user.profileImage?.url && (
              <div className="w-[35px] h-[35px] flex items-center justify-center font-bold text-xl text-white rounded-full bg-[#248358]">
                {user?.first_name?.[0] || user?.company_name?.[0]}
              </div>
            )}
          </div>
          <div className="flex flex-col ">
            <h4 className="font-black p-0 m-0 leading-[16px]  ">
              {user?.first_name || user.company_name} {user.last_name || ""}
            </h4>
          </div>
        </div>
        <div className="w-full  flex flex-col gap-4 mt-4 cursor-pointer">
          <Link
            to={"/dashboard/seller"}
            className="hover:bg-gray-50 border-b border-dashed p-2 cursor-pointer flex items-center gap-2 text-gray-700 font-medium"
          >
            <Store /> <span>{t("My account")}</span>
          </Link>
          <Link
            to={"/dashboard/buyer/order-history"}
            className="hover:bg-gray-50 border-b border-dashed p-2 cursor-pointer flex items-center gap-2 text-gray-700 font-medium"
          >
            <TruckIcon /> <span>{t("My orders")}</span>
          </Link>
          <Link
            to={"/dashboard/buyer/manage-addresses"}
            className="hover:bg-gray-50 border-b border-dashed p-2 cursor-pointer flex items-center gap-2 text-gray-700 font-medium"
          >
            <WalletIcon /> <span>{t("Payment method")}</span>
          </Link>
          <a
            href="https://guide.insta-pay.ch/"
            target="_blank"
            rel="noopener noreferrer"
            className="hover:bg-gray-50 border-b border-dashed p-2 cursor-pointer flex items-center gap-2 text-gray-700 font-medium"
          >
            <HeadphonesIcon /> <span>{t("Help and Support")}</span>
          </a>

          <button
            onClick={handleLogout}
            className="hover:bg-gray-50 border-b border-dashed p-2 cursor-pointer flex items-center gap-2 text-red-500 font-medium"
          >
            <LogOut /> <span>{t("Logout")}</span>
          </button>
        </div>
      </div>
    </div>
  );
}

export default MobileHeaderDropdown;
